import React from 'react';

const ChevronRightSvg = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            className="links__svg"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 45 45"
            {...props}
        >
            <g fill="none" fillRule="evenodd">
                <path
                    stroke="#000"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    className="chevron"
                    d="M26 13 16 23l10 10"
                />
            </g>
        </svg>
    );
};

export default ChevronRightSvg;
